export interface PerDiemDoc {
  manPowerRequirementStatusID: string;
  manPowerRequirementID: string;
  name: string;
}
